<template>
  <v-container class="event-checkin-page finviz-dark-page work-sans-font" fluid style="background-color: #0f1419 !important; padding: 0 !important;">
    <v-layout row justify-center >
      <v-dialog v-model="popupbox" max-width="800px" hide-overlay>
        <v-card class="edit-dialog-card">
          <v-card-title class="edit-dialog-header">
            <v-icon color="white" class="mr-2">mdi-pencil</v-icon>
            <span class="white--text">Edit Event Data</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="close()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-6">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field ref="Json.firstname" outlined dense :rules="nameRules" v-model="Json.firstname" label="First Name" required></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field ref="Json.lastname" outlined dense :rules="nameRules" v-model="Json.lastname" label="Last Name"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field ref="Json.primaryemail" outlined dense :rules="nameRules" v-model="Json.primaryemail" label="Primary Email" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select ref="Json.membershipcategory" outlined dense :items="['Family', 'Paarivallal', 'Single', 'NonMember']" v-model="Json.membershipcategory" label="Membership"></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select ref="Json.checkinstatus" dense required v-model="Json.checkinstatus" :items="['Y','N']" outlined label="Checkin"></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field ref="Json.event" outlined dense v-model="Json.event" label="Event"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select ref="Json.eventpayment" dense v-model="Json.eventpayment" :items="['Paid', 'Not Paid', 'Partially Paid']" outlined label="Event Payment"></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field type="number" step="any" min="0" :rules="[numberRule]" ref="Json.adultsCount" dense required v-model.number="Json.adultsCount" outlined label="Adults Count"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field type="number" step="any" min="0" :rules="[numberRule]" ref="Json.KCount" dense required v-model.number="Json.KCount" outlined label="Kids Count"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field type="number" step="any" min="0" :rules="[numberRule]" ref="Json.PCount" dense required v-model.number="Json.PCount" outlined label="Parents Count"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field type="number" step="any" min="0" :rules="[numberRule]" ref="Json.totalAmount" dense required v-model.number="Json.totalAmount" outlined label="Total Amount"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field step="any" min="0" ref="Json.comments" dense required v-model.number="Json.comments" outlined label="Comments"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn outlined color="grey" @click="close()">Close</v-btn>
            <v-btn color="primary" @click="update()" :disabled="!valid">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="popup" persistent max-width="400">
        <v-card class="delete-dialog-card">
          <v-card-title class="delete-dialog-header">
            <v-icon color="white" class="mr-2">mdi-alert-circle</v-icon>
            <span class="white--text">Confirmation</span>
          </v-card-title>
          <v-card-text class="pa-6 text-center">
            <p class="text-h6">Are you sure you want to delete this information?</p>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn outlined color="grey" @click="close()">Cancel</v-btn>
            <v-btn color="error" @click="confirmdelete(id)">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Stats Cards Section -->
    <!-- New Dashboard Stats Design - Collapsible -->
    <div class="stats-dashboard pt-10 px-0 pb-1">
      <v-container fluid class="pa-0" style="background-color: #0f1419 !important;">
        <!-- Collapsible Header -->
        <v-card class="stats-header-card mb-1" elevation="0" @click="toggleStats">
          <v-card-text class="pa-1 px-2">
            <div class="d-flex align-center justify-space-between stats-header-clickable">
              <div class="d-flex align-center">
                <v-icon size="18" class="mr-2" style="color: #3399ff !important;">mdi-chart-box-outline</v-icon>
                <div>
                  <h3 class="text-body-2 mb-0 font-weight-bold" style="color: #d3d3d3 !important;">Event Statistics</h3>
                  <p class="text-caption mb-0" style="font-size: 0.65rem; color: #999999 !important;">Click to {{ statsExpanded ? 'hide' : 'view' }} details</p>
                </div>
              </div>
              <div class="d-flex align-center">
                <!-- Quick Stats Preview when collapsed -->
                <div v-if="!statsExpanded" class="mr-1 d-none d-sm-flex">
                  <v-chip x-small color="#764ba2" text-color="white" class="mr-1 compact-chip font-weight-bold">
                    <v-icon x-small left>mdi-account-group</v-icon>
                    {{ this.getTotalCount() }}
                  </v-chip>
                  <v-chip x-small color="#00c9ff" text-color="white" class="mr-1 compact-chip font-weight-bold">
                    <v-icon x-small left>mdi-cash-check</v-icon>
                    {{ this.getFullyPaidCount() + this.getPartialPaidCount() }}
                  </v-chip>
                  <v-chip x-small color="#f093fb" text-color="white" class="compact-chip font-weight-bold">
                    <v-icon x-small left>mdi-checkbox-marked</v-icon>
                    {{ this.checkedInCount() }}
                  </v-chip>
                </div>
                <v-btn icon x-small dark>
                  <v-icon x-small style="color: #999999 !important;">{{ statsExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- Expandable Stats Content -->
        <v-expand-transition>
          <div v-show="statsExpanded">

        <!-- Checked In Summary Card -->
        <v-row dense class="mb-1">
          <v-col cols="12" class="pa-1">
            <v-card class="checked-in-summary-card" elevation="1">
              <v-card-text class="pa-2">
                <v-row align="center" no-gutters>
                  <v-col cols="auto" class="pr-3">
                    <v-avatar size="48" color="success" class="elevation-2">
                      <v-icon color="white" size="28">mdi-account-check</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col>
                    <div class="checked-in-label">Total Checked In</div>
                    <div class="checked-in-value success--text">{{ this.checkedInCount() }} / {{ this.getTotalCount() }}</div>
                  </v-col>
                  <v-col cols="auto">
                    <v-chip
                      :color="getCheckInPercentage() >= 75 ? 'success' : getCheckInPercentage() >= 50 ? 'orange' : 'error'"
                      dark
                      label
                      class="font-weight-bold"
                    >
                      {{ getCheckInPercentage() }}%
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Payment Status Table -->
        <v-row dense class="mb-1">
          <v-col cols="12" class="pa-0">
            <v-card class="stats-table-card" elevation="1">
              <v-simple-table dense class="payment-stats-table compact-stats-table">
                <template v-slot:default>
                  <thead>
                    <tr class="stats-header-row">
                      <th class="text-left stats-header-cell">Category</th>
                      <th class="text-center stats-header-cell paid-header">Paid</th>
                      <th class="text-center stats-header-cell partial-paid-header">Partially Paid</th>
                      <th class="text-center stats-header-cell not-paid-header">Not Paid</th>
                      <th class="text-center stats-header-cell total-header">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="stats-row">
                      <td class="stats-label-cell">Parents</td>
                      <td class="text-center stats-value-cell paid-cell">{{ getParentsByPayment('Paid') }}</td>
                      <td class="text-center stats-value-cell partial-paid-cell">{{ getParentsByPayment('Partially Paid') }}</td>
                      <td class="text-center stats-value-cell not-paid-cell">{{ getParentsByPayment('Not Paid') }}</td>
                      <td class="text-center stats-value-cell total-cell">{{ getParentsByPayment('Paid') + getParentsByPayment('Partially Paid') + getParentsByPayment('Not Paid') }}</td>
                    </tr>
                    <tr class="stats-row">
                      <td class="stats-label-cell">Kids</td>
                      <td class="text-center stats-value-cell paid-cell">{{ getKidsByPayment('Paid') }}</td>
                      <td class="text-center stats-value-cell partial-paid-cell">{{ getKidsByPayment('Partially Paid') }}</td>
                      <td class="text-center stats-value-cell not-paid-cell">{{ getKidsByPayment('Not Paid') }}</td>
                      <td class="text-center stats-value-cell total-cell">{{ getKidsByPayment('Paid') + getKidsByPayment('Partially Paid') + getKidsByPayment('Not Paid') }}</td>
                    </tr>
                    <tr class="stats-row">
                      <td class="stats-label-cell">Adults</td>
                      <td class="text-center stats-value-cell paid-cell">{{ getAdultsByPayment('Paid') }}</td>
                      <td class="text-center stats-value-cell partial-paid-cell">{{ getAdultsByPayment('Partially Paid') }}</td>
                      <td class="text-center stats-value-cell not-paid-cell">{{ getAdultsByPayment('Not Paid') }}</td>
                      <td class="text-center stats-value-cell total-cell">{{ getAdultsByPayment('Paid') + getAdultsByPayment('Partially Paid') + getAdultsByPayment('Not Paid') }}</td>
                    </tr>
                    <tr class="stats-total-row">
                      <td class="stats-total-label">Total</td>
                      <td class="text-center stats-total-value paid-total">{{ getTotalByPayment('Paid') }}</td>
                      <td class="text-center stats-total-value partial-paid-total">{{ getTotalByPayment('Partially Paid') }}</td>
                      <td class="text-center stats-total-value not-paid-total">{{ getTotalByPayment('Not Paid') }}</td>
                      <td class="text-center stats-total-value grand-total">{{ getTotalByPayment('Paid') + getTotalByPayment('Partially Paid') + getTotalByPayment('Not Paid') }}</td>
                    </tr>
                    <tr class="stats-total-hc-row">
                      <td class="stats-total-hc-label">Total Head Count</td>
                      <td colspan="2" class="text-center stats-total-hc-value paid-hc-total">{{ getTotalByPayment('Paid') + getTotalByPayment('Partially Paid') }}</td>
                      <td class="text-center stats-total-hc-value">{{ getTotalByPayment('Not Paid') }}</td>
                      <td class="text-center stats-total-hc-value grand-total">{{ getTotalByPayment('Paid') + getTotalByPayment('Partially Paid') + getTotalByPayment('Not Paid') }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
          </div>
        </v-expand-transition>
      </v-container>
    </div>

    <!-- Filters and Actions Section -->
    <v-card class="mb-2 filters-card" elevation="0" style="margin-left: 0 !important; margin-right: 0 !important;">
      <v-card-text class="pa-2">
        <v-row align="center" dense no-gutters class="flex-nowrap">
          <v-col cols="auto" class="px-1" style="flex: 0 0 auto; width: 200px;">
            <v-text-field
              dense
              outlined
              placeholder="Search..."
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              hide-details
              class="filter-input"
              dark
            ></v-text-field>
          </v-col>

          <v-col cols="auto" class="px-1" style="flex: 0 0 auto; width: 150px;">
            <v-autocomplete
              outlined
              dense
              placeholder="Membership"
              label="Membership"
              :items="['','Paarivallal', 'Family', 'Single', 'NonMember']"
              v-model="membershipCategory"
              hide-details
              class="filter-input"
              dark
            ></v-autocomplete>
          </v-col>

          <v-col cols="auto" class="px-1" style="flex: 0 0 auto; width: 140px;">
            <v-autocomplete
              outlined
              dense
              placeholder="Payment"
              label="Payment"
              :items="['','Paid', 'Partially Paid', 'Not Paid']"
              v-model="paymentStatus"
              hide-details
              class="filter-input"
              dark
            ></v-autocomplete>
          </v-col>

          <v-col cols="auto" class="px-1" style="flex: 0 0 auto; width: 140px;">
            <v-autocomplete
              outlined
              dense
              placeholder="Event"
              disabled
              label="Event"
              :items="['','pongal2026','Vikkals-2025','VIV-2026', 'MeetAndGreet-2024', 'NeeyaNaana-2024']"
              v-model="event"
              hide-details
              class="filter-input"
              dark
            ></v-autocomplete>
          </v-col>

          <v-col class="text-right px-1">
            <v-btn dark outlined small class="mr-2 filter-btn" @click="clear()">
              <v-icon left small>mdi-close-circle</v-icon>
              Clear Filters
            </v-btn>
            <v-btn icon small dark class="mr-2" @click.stop="refresh()">
              <v-icon>mdi-autorenew</v-icon>
            </v-btn>
            <v-btn icon small dark @click="exportToExcel()">
              <v-icon>mdi-file-excel</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Data Table Section -->
    <v-card class="mb-3 data-table-card" elevation="0" style="margin-left: 0 !important; margin-right: 0 !important;">
      <v-data-table
        dense
        :headers="headers"
        :items-per-page="25"
        v-bind:items="filteredItems"
        v-bind:search="search"
        :sort-by="['submitedDate']"
        :sort-desc="[true]"
        multi-sort
        item-key="_id"
        class="modern-table"
        :loading="loading"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        show-expand
      >
      <template v-slot:item.checkinstatus="{ item }">
        <v-switch
          :input-value="item.eventCheckIn === 'Y'"
          @change="toggleCheckIn(item, $event)"
          :loading="item.loading"
          dense
          inset
          color="success"
          hide-details
          class="mt-0 pt-0 check-in-toggle"
        >
          <template v-slot:label>
            <span :class="item.eventCheckIn === 'Y' ? 'success--text font-weight-bold' : 'error--text'" style="font-size: 14px;">
              {{ item.eventCheckIn === 'Y' ? 'Yes' : 'No' }}
            </span>
          </template>
        </v-switch>
      </template>
      <template v-slot:item.ctc="{ item }">
        <div v-if="item.checkinstatus === 'Y'">
          <v-avatar size="20" class="green darken-1 elevation-5">
            <v-icon color="white" style="font-size: 15px;">{{
              item.checkinstatus
            }}</v-icon></v-avatar
          >
        </div>
      </template>
      <template v-slot:item.Edit="{ item }">
        <v-avatar size="28" class="green lighten-1 elevation-2">
          <v-icon small @click="getEventById(item._id)"
          >mdi-pencil</v-icon
        >
        </v-avatar>
      </template>
      <template v-slot:item.UnCheckIn="{ item }">
        <v-avatar size="26" class="light-blue lighten-3 elevation-2"
        ><v-icon medium @click="deleteCheckIn(item._id)"
          >mdi-account-off</v-icon
        ></v-avatar >
      </template>
      <template v-slot:item.Delete="{ item }">
        <v-avatar size="28" class="red lighten-2 elevation-2">
        <v-icon small @click="deleteEventData(item._id)"
          >mdi-delete</v-icon
        >
        </v-avatar>
      </template>
      <template v-slot:item.uncheckin="{ item }">
        <v-avatar size="26" class="blue lighten-3 elevation-5 mx-1"
        ><v-icon medium @click="deleteCheckIn(item._id)"
          >mdi-account-off</v-icon
        ></v-avatar
      >
      </template>
      <template v-slot:item.totalAmount="{ item }">
        <span>$ {{ item.totalAmount }}</span>
      </template>
      <template v-slot:item.eventpayment="{ item }">
        <v-tooltip bottom max-width="600" color="#FF9800" content-class="payment-comment-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              label
              :color="getPaymentColor(item.eventpayment)"
              class="caption"
              small
              dark
              v-bind="attrs"
              v-on="on"
            >
              {{ getPaymentInfo(item.eventpayment) }}
            </v-chip>
          </template>
          <span style="white-space: pre-wrap; word-wrap: break-word; color: #000000; font-weight: 500; line-height: 1.6;">{{ item.comments || 'No comments available' }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.membershipcategory="{ item }">
        <v-chip
          label
          :color="getMemberColor(item.membershipcategory)"
          class="caption"
          outlined
          small
          dark
          >{{ (item.membershipcategory) }}</v-chip
        >
      </template>
      <template v-slot:item.primaryemail="{ item }">
        <span class="email-link">{{ item.primaryemail }}</span>
      </template>
      <template v-slot:item.totalAmount="{ item }">
        <span class="amount-value">{{ item.totalAmount }}</span>
      </template>
      </v-data-table>
    </v-card>

  </v-container>
</template>

<script>
import ReportServices from "@/services/ReportServices";
import XLSX from "xlsx";

export default {
  name: 'DataTable',
  data() {
    return {
      statsExpanded: false, // Stats section collapsed by default
      membershipCategory: null,
      paymentStatus: null,
      expanded: [],
      singleExpand: false,
      totalAmount: 0,
      selected: [],
      allEventsData: [],
      allCheckInStatus: [],
      getMembershipCount: "",
      allCount: "",
      search: "",
      event: 'VIV-2026',
      loading: true,
      Json: {
        _id: "",
        firstname: "",
        lastname: "",
        primaryemail: "",
        membershipcategory: "",
        paymentstatus: "",
        year: "",
        checkinstatus: "",
        event: "",
        CBCount:0,
        GBCount: 0,
        adultsCount:0,
        VBCount: 0,
        totalCount:0,
        comments: "",
        submitedDate: "",
        totalAmount: 0
      },
      select: null,
      valid: true,
      name: "",
      nameRules: [(v) => !!v || "This Field is required"],
      numberRule: val => {
      if(val < 0) return 'Please enter a positive number'
        return true
      },
      comment: null,
      popupbox: false,
      popup: false,
    };
  },
  computed: {
    loggedInUser() {
      var user = this.$store.getters.email;
      var role = this.$store.getters.role;
      if (user && role === "SuperAdmin") return "SuperAdmin";
      else if (user && role === "Admin") return "Admin";
      else if (user && role === "Member") return "Member";
      else return null;
    },
    headers () {
        if (this.loggedInUser ==='SuperAdmin' && this.event === 'NeeyaNaana-2024') {
          return [
            { text: "Checked-In", align: "left", value: "checkinstatus", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true,width: "180px" },
            { text: "Total", align: "center", value: "adultsCount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "GB", align: "center", value: "GBCount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "CB", align: "center", value: "CBCount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "VB", align: "center", value: "VBCount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Amount", align: "center", value: "totalAmount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Payments", align: "left", value: "eventpayment", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Membership", align: "left", value: "membershipcategory", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Name", align: "left", value: "firstname",  sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Email Id", align: "left", value: "primaryemail", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "UnCheck", align: "center", value: "UnCheckIn", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true,width: "1%" },
            { text: "Edit",  align: "left", value: "Edit", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true , width: "1%"},
            { text: "Delete",  align: "left", value: "Delete", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
            { text: '', value: 'data-table-expand' },
          ]
        } else if (this.loggedInUser ==='SuperAdmin' && this.event === 'VIV-2026'){
          return [
            { text: "Checked-In", align: "left", value: "checkinstatus", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true,width: "180px" },
            { text: "Name", align: "left", value: "firstname",  sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Email Id", align: "left", value: "primaryemail", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Adults", align: "center", value: "adultsCount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Kids", align: "center", value: "KCount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Parents", align: "center", value: "PCount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "TotalAmount", align: "center", value: "totalAmount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Payments", align: "left", value: "eventpayment", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Membership", align: "left", value: "membershipcategory", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            //{ text: "TimeSlot", align: "center", value: "timeSlot", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            //{ text: "UnCheck", align: "center", value: "UnCheckIn", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true,width: "1%" },
            { text: "Edit",  align: "left", value: "Edit", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true , width: "1%"},
            { text: "Delete",  align: "left", value: "Delete", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
            { text: '', value: 'data-table-expand' },
          ]
        } else if (this.event === 'pongal2026'){
          return [
            { text: "Checked-In", align: "left", value: "checkinstatus", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true,width: "180px" },
            { text: "Adults", align: "center", value: "adultsCount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Kids", align: "center", value: "Kcount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "FirstName", align: "left", value: "firstname",  sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "LastName", align: "left", value: "lastname",  sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Primary Email", align: "left", value: "primaryemail", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "NonMemberAdults", align: "center", value: "adultsCount-nonmember", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Membership", align: "left", value: "membershipcategory", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "UnCheck", align: "center", value: "UnCheckIn", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true,width: "1%" },
            //{ text: "Edit",  align: "left", value: "Edit", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true , width: "1%"},
            { text: "Delete",  align: "left", value: "Delete", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
            //{ text: '', value: 'data-table-expand' },
          ]
        } else {
          return [
            { text: "Check In", align: "left", value: "checkinstatus", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true,width: "180px" },
            { text: "Adults", align: "center", value: "adultsCount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "TotalAmount", align: "center", value: "totalAmount", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Payments", align: "left", value: "eventpayment", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Membership", align: "left", value: "membershipcategory", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Name", align: "left", value: "firstname",  sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "Email Id", align: "left", value: "primaryemail", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true },
            { text: "UnCheck", align: "center", value: "UnCheckIn", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true,width: "1%" },
            { text: "Edit",  align: "left", value: "Edit", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true , width: "1%"},
            { text: "Delete",  align: "left", value: "Delete", sortable: true, class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
            { text: '', value: 'data-table-expand' },
          ]
        }
    },
    filteredItems () {
      return this.allCheckInStatus.filter(i => {
        // Check event filter
        if (this.event && i.event !== this.event) {
          return false;
        }

        // Check membership filter
        if (this.membershipCategory && i.membershipcategory !== this.membershipCategory) {
          return false;
        }

        // Check payment status filter
        if (this.paymentStatus) {
          if (this.paymentStatus === 'Paid' && i.eventpayment !== 'Paid') {
            return false;
          }
          if (this.paymentStatus === 'Partially Paid' && i.eventpayment !== 'Partially Paid') {
            return false;
          }
          if (this.paymentStatus === 'Not Paid' && (i.eventpayment === 'Paid' || i.eventpayment === 'Partially Paid')) {
            return false;
          }
        }

        return true;
    })
  }},
  methods: {
    exportToExcel() {
      var allCheckInStatus = XLSX.utils.json_to_sheet(this.allCheckInStatus);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, allCheckInStatus, "allCheckInStatus");
      XLSX.writeFile(wb, "allCheckInStatus.xlsx");
    },
    getMemberColor (status) {
      if (status === 'Paarivallal') return 'purple'
      else if (status === 'Family') return 'green'
      else if (status === 'Single') return 'green'
      else return 'red' 
    },
    async getMemberCategory (email) {
      return (await ReportServices.validateMembership(email)).data;
    },
    getPaymentColor (eventpayment) {
      if (eventpayment === 'Paid') return 'green'
      else if (eventpayment === 'Partially Paid') return 'orange'
      else return 'red'
    },
    getPaymentInfo (eventpayment) {
      if (eventpayment === 'Paid') return 'Paid'
      else if (eventpayment === 'Partially Paid') return 'Partially Paid'
      else return 'Not Paid'
    },
    print() {
      window.print();
    },
    logoutFromFirebase() {
      this.$store
        .dispatch("signOutAction")
        .then(() => this.$router.replace("/Signin"));
    },
    clear() {
      this.search = "";
      this.membershipCategory = null;
      this.paymentStatus = null;
      this.Json.firstname = "",
      this.Json.lastname=  "",
      this.Json.primaryemail=  "",
      this.Json.membershipcategory=  "",
      this.Json.eventpayment=  "",
      this.Json.year=  "",
      this.Json.checkinstatus=  "",
      this.Json.event=  "",
      this.Json.VBCount= "",
      this.Json.adultsCount= "",
      this.Json.CBCount=  "",
      this.Json.GBCount=  "",
      this.Json.totalCount= "",
      this.Json.comments=  "",
      this.Json.submitedDate=  "",
      this.Json.totalAmount=  0,
      this.Json.comments= ""
    },
    close () {
      this.popupbox = false
      this.popup = false
    },
    getColor(ctc) {
      if (ctc === "Y") return "green";
      else return "red";
    },
    deleteCheckIn(id) {
      ReportServices.deleteCheckIn(id);
      setTimeout(() => {
        this.refresh();
      }, 300);
    },
    update () {
        ReportServices.updateEventData(this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 300)
    },
    deleteEventData(id) {
      if (this.loggedInUser === "SuperAdmin") {
        ReportServices.deleteEventData(id);
        setTimeout(() => {
          this.refresh();
        }, 300);
      }
    },
    getNonMembersCount() {
      return this.allCheckInStatus.filter(
        (x) => x.membershipcategory === "NonMember"
      ).length;
    },
    getMembersCount() {
      return this.allCheckInStatus.filter(
        (x) => x.membershipcategory !== "NonMember"
      ).length;
    },
    getConfirmedCount() {
      return this.allCheckInStatus.filter(
        (x) => x.paymentstatus === "Not Paid"
      ).length;
    },
    amountReceived() {
      var totalAmt = 0;
      this.allCheckInStatus.forEach((sInfo) => {
        if (sInfo.eventpayment === "Paid") {
        totalAmt += sInfo.totalAmount
        }
      });
      return totalAmt;
    },
    notPaidCount() {
      const result = this.allCheckInStatus.filter(sInfo => sInfo.eventpayment !== "Paid").length
      return result
      },
    async unselect() {
      this.selected = [];
    },
    isCheckedIn(id) {
      const userExists = this.allCheckInStatus.some((user) => user._id === id);
      if (userExists) {
        return true;
      }
    },
    checkedInCount() {
      var sum = 0
      this.allCheckInStatus.forEach(item => {
        if (item.eventCheckIn ==="Y" && item.event === this.event) {
          sum += item.adultsCount + item.KCount + item.PCount;
        }
      });
      return sum || 0
    },
    getFamilyCount() {
      var fCount = []
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event) {
          fCount.push(item.primaryemail)
        }
      });
      return fCount.length
    },
    getPaidCount() {
      var vCount = []
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event && item.eventpayment === 'Paid') {
          vCount.push(item.primaryemail)
      }
    })
     return vCount.length
    },
    getAdultsCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event) {
          vCount += item.adultsCount + item.PCount
      }
    })
     return vCount || 0
    },
    getPaidAdultsCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event && item.event === 'VIV-2026' && (item.eventpayment === 'Paid' || item.eventpayment === 'Partially Paid')) {
          vCount += item.adultsCount + item.PCount
      }
    })
     return vCount || 0
    },
    getKidsCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event) {
          vCount += item.KCount;
      }
    })
     return vCount || 0
    },
    getPaidKidsCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event && item.event === 'VIV-2026' && (item.eventpayment === 'Paid' || item.eventpayment === 'Partially Paid')) {
          vCount += item.KCount;
      }
    })
     return vCount || 0
    },
    getYouthCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event) {
          vCount += item.PCount;
      }
    })
     return vCount
    },
    getParentsCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event) {
          vCount += item.PCount;
      }
    })
     return vCount || 0
    },
    getTotalCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event) {
          vCount += item.adultsCount + item.KCount + item.PCount;
        }
    })
     return vCount || 0
    },
    getPaidTotalCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event && (item.eventpayment === 'Paid' || item.eventpayment === 'Partially Paid')) {
          vCount += item.adultsCount + item.KCount + item.PCount;
        }
    })
     return vCount || 0
    },
    getFullyPaidCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event && item.eventpayment === 'Paid') {
          vCount += item.adultsCount + item.KCount + item.PCount;
        }
    })
     return vCount || 0
    },
    getPartialPaidCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event && item.eventpayment === 'Partially Paid') {
          vCount += item.adultsCount + item.KCount + item.PCount;
        }
    })
     return vCount || 0
    },
    getNotPaidCount() {
      var vCount = 0
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event && item.eventpayment !== 'Paid' && item.eventpayment !== 'Partially Paid') {
          vCount += item.adultsCount + item.KCount + item.PCount;
        }
    })
     return vCount || 0
    },
    // New methods for payment status table
    getParentsByPayment(paymentStatus) {
      var count = 0;
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event && item.event === 'VIV-2026') {
          // Not Paid includes blank/empty eventpayment
          if (paymentStatus === 'Not Paid') {
            if (!item.eventpayment || (item.eventpayment !== 'Paid' && item.eventpayment !== 'Partially Paid')) {
              count += item.PCount || 0;
            }
          } else if (item.eventpayment === paymentStatus) {
            count += item.PCount || 0;
          }
        }
      });
      return count;
    },
    getKidsByPayment(paymentStatus) {
      var count = 0;
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event && item.event === 'VIV-2026') {
          // Not Paid includes blank/empty eventpayment
          if (paymentStatus === 'Not Paid') {
            if (!item.eventpayment || (item.eventpayment !== 'Paid' && item.eventpayment !== 'Partially Paid')) {
              count += item.KCount || 0;
            }
          } else if (item.eventpayment === paymentStatus) {
            count += item.KCount || 0;
          }
        }
      });
      return count;
    },
    getAdultsByPayment(paymentStatus) {
      var count = 0;
      this.allCheckInStatus.forEach(item => {
        if (item.event === this.event && item.event === 'VIV-2026') {
          // Not Paid includes blank/empty eventpayment
          if (paymentStatus === 'Not Paid') {
            if (!item.eventpayment || (item.eventpayment !== 'Paid' && item.eventpayment !== 'Partially Paid')) {
              count += item.adultsCount || 0;
            }
          } else if (item.eventpayment === paymentStatus) {
            count += item.adultsCount || 0;
          }
        }
      });
      return count;
    },
    getTotalByPayment(paymentStatus) {
      return this.getParentsByPayment(paymentStatus) +
             this.getKidsByPayment(paymentStatus) +
             this.getAdultsByPayment(paymentStatus);
    },
    getCheckInPercentage() {
      const total = this.getTotalCount();
      const checkedIn = this.checkedInCount();
      if (total === 0) return 0;
      return Math.round((checkedIn / total) * 100);
    },
    toggleStats() {
      this.statsExpanded = !this.statsExpanded
    },
    async getEventById (id) {
      if (id) {
        this.popupbox = true
        this.CommentInfo = (await ReportServices.getEventById(id)).data
        this.Json= this.CommentInfo
      }
    },
    async toggleCheckIn(item, isCheckedIn) {
      // Set loading state
      this.$set(item, 'loading', true);

      if (isCheckedIn) {
        // Check in the user
        const checkIns = [{ _id: item._id }];
        await ReportServices.submitFDCheckIn(checkIns);
      } else {
        // Uncheck the user
        await ReportServices.deleteCheckIn(item._id);
      }

      // Refresh data after a short delay
      setTimeout(() => {
        this.refresh();
      }, 300);
    },
    async submitCheckIn() {
      var checkIns = [];
      this.allCheckInStatus.forEach((sInfo) => {
        var checkInDetails = "";
        var isFound = false;
        this.selected.forEach((i) => {
          if (sInfo._id === i._id) {
            isFound = true;
          }
        });
        if (isFound) {
          checkInDetails = {
            _id: sInfo._id,
          };
        } else return;
        checkIns.push(checkInDetails);
      });
      ReportServices.submitFDCheckIn(checkIns);
      setTimeout(() => {
        this.refresh();
        this.unselect();
      }, 500);
    },
    async refresh() {
      this.loading = true;
      this.allCheckInStatus = (await ReportServices.getFDstatus()).data;
      this.getMembershipCount = (await ReportServices.getMembershipCount()).data;
      this.getMemberCat = (await ReportServices.validateMembership()).data;
      this.loading = false;
      this.noDataText = "No data available";
    },
  },
  async mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
  * {
    box-sizing: border-box;
    text-transform: none;
  }

  .event-checkin-page {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;
    padding-top: 16px !important;
  }

  /* Edit Dialog Styles */
  .edit-dialog-card {
    border-radius: 16px !important;
    overflow: hidden;
  }

  .edit-dialog-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    font-size: 1.2rem;
    font-weight: 600;
    padding: 20px 24px;
  }

  /* Delete Dialog Styles */
  .delete-dialog-card {
    border-radius: 16px !important;
    overflow: hidden;
  }

  .delete-dialog-header {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: white;
    font-size: 1.2rem;
    font-weight: 600;
    padding: 20px 24px;
  }

  /* Stats Section */
  .stats-section {
    background: transparent;
    margin-top: 0 !important;
  }

  /* Desktop view: All 9 cards in single row extending to full width */
  @media (min-width: 1264px) {
    .stats-row-desktop {
      flex-wrap: nowrap !important;
      margin-left: -4px !important;
      margin-right: -4px !important;
    }

    .stat-col-desktop {
      flex: 0 0 11.111% !important;
      max-width: 11.111% !important;
      min-width: 0 !important;
      padding: 0 4px !important;
    }
  }

  .stat-card {
    border-radius: 16px !important;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    border: none !important;
    overflow: hidden;
    position: relative;
    height: 100%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  }

  .stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: currentColor;
  }

  .stat-card:hover {
    transform: translateY(-6px) scale(1.02);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15) !important;
  }

  .stat-card-blue {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: #667eea;
  }
  .stat-card-blue .stat-label,
  .stat-card-blue .stat-value {
    color: white !important;
  }
  .stat-card-blue .v-avatar {
    background: rgba(255, 255, 255, 0.25) !important;
  }
  .stat-card-blue .v-icon {
    color: white !important;
  }

  .stat-card-green {
    background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%) !important;
    color: #11998e;
  }
  .stat-card-green .stat-label,
  .stat-card-green .stat-value {
    color: white !important;
  }
  .stat-card-green .v-avatar {
    background: rgba(255, 255, 255, 0.25) !important;
  }
  .stat-card-green .v-icon {
    color: white !important;
  }

  .stat-card-purple {
    background: linear-gradient(135deg, #7f00ff 0%, #e100ff 100%) !important;
    color: #7f00ff;
  }
  .stat-card-purple .stat-label,
  .stat-card-purple .stat-value {
    color: white !important;
  }
  .stat-card-purple .v-avatar {
    background: rgba(255, 255, 255, 0.25) !important;
  }
  .stat-card-purple .v-icon {
    color: white !important;
  }

  .stat-card-teal {
    background: linear-gradient(135deg, #0ba360 0%, #3cba92 100%) !important;
    color: #0ba360;
  }
  .stat-card-teal .stat-label,
  .stat-card-teal .stat-value {
    color: white !important;
  }
  .stat-card-teal .v-avatar {
    background: rgba(255, 255, 255, 0.25) !important;
  }
  .stat-card-teal .v-icon {
    color: white !important;
  }

  .stat-card-orange {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%) !important;
    color: #f5576c;
  }
  .stat-card-orange .stat-label,
  .stat-card-orange .stat-value {
    color: white !important;
  }
  .stat-card-orange .v-avatar {
    background: rgba(255, 255, 255, 0.25) !important;
  }
  .stat-card-orange .v-icon {
    color: white !important;
  }

  .stat-card-pink {
    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%) !important;
    color: #fa709a;
  }
  .stat-card-pink .stat-label,
  .stat-card-pink .stat-value {
    color: white !important;
  }
  .stat-card-pink .v-avatar {
    background: rgba(255, 255, 255, 0.25) !important;
  }
  .stat-card-pink .v-icon {
    color: white !important;
  }

  .stat-card-indigo {
    background: linear-gradient(135deg, #4e54c8 0%, #8f94fb 100%) !important;
    color: #4e54c8;
  }
  .stat-card-indigo .stat-label,
  .stat-card-indigo .stat-value {
    color: white !important;
  }
  .stat-card-indigo .v-avatar {
    background: rgba(255, 255, 255, 0.25) !important;
  }
  .stat-card-indigo .v-icon {
    color: white !important;
  }

  .stat-card-cyan {
    background: linear-gradient(135deg, #00d2ff 0%, #3a47d5 100%) !important;
    color: #00d2ff;
  }
  .stat-card-cyan .stat-label,
  .stat-card-cyan .stat-value {
    color: white !important;
  }
  .stat-card-cyan .v-avatar {
    background: rgba(255, 255, 255, 0.25) !important;
  }
  .stat-card-cyan .v-icon {
    color: white !important;
  }

  .stat-card-deep-purple {
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%) !important;
    color: #ff6b6b;
  }
  .stat-card-deep-purple .stat-label,
  .stat-card-deep-purple .stat-value {
    color: white !important;
  }
  .stat-card-deep-purple .v-avatar {
    background: rgba(255, 255, 255, 0.25) !important;
  }
  .stat-card-deep-purple .v-icon {
    color: white !important;
  }

  .stat-label {
    font-size: 0.7rem;
    font-weight: 600;
    margin-bottom: 4px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    opacity: 0.95;
  }

  .stat-value {
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1.2;
  }

  /* Desktop specific sizing for compact cards */
  @media (min-width: 1264px) {
    .stat-card .v-avatar {
      width: 24px !important;
      height: 24px !important;
      min-width: 24px !important;
    }

    .stat-card .v-avatar .v-icon {
      font-size: 14px !important;
    }

    .stat-card .v-card__text {
      padding: 6px 4px !important;
    }

    .stat-card .d-flex {
      gap: 4px !important;
    }

    .stat-label {
      font-size: 0.55rem !important;
      line-height: 1 !important;
    }

    .stat-value {
      font-size: 0.95rem !important;
      line-height: 1.1 !important;
    }
  }

  /* Google Font Import */
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');

  /* DM Sans Font Application */
  .work-sans-font,
  .work-sans-font * {
    font-family: 'DM Sans', sans-serif !important;
  }

  .work-sans-font {
    font-size: 15px !important;
  }

  /* Finviz Dark Page Background - Apply Globally */
  body {
    background-color: #0f1419 !important;
  }

  html {
    background-color: #0f1419 !important;
  }

  .v-application {
    background-color: #0f1419 !important;
  }

  .v-application .v-main {
    background-color: #0f1419 !important;
  }

  .v-application__wrap {
    background-color: #0f1419 !important;
  }

  .v-content__wrap {
    background-color: #0f1419 !important;
  }

  .finviz-dark-page {
    background-color: #0f1419 !important;
    min-height: 100vh !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .event-checkin-page {
    background-color: #0f1419 !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .container {
    background-color: #0f1419 !important;
    margin: 0 !important;
  }

  .v-container {
    background-color: #0f1419 !important;
    margin: 0 !important;
  }

  .v-container.container--fluid {
    background-color: #0f1419 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /* Filters Card - Finviz Dark Style */
  .filters-card {
    border-radius: 0 !important;
    background-color: #2c3e50 !important;
    border: 1px solid #3d5469 !important;
  }

  .filters-card .v-row {
    flex-wrap: nowrap !important;
  }

  /* Filter Input Styling - Finviz Style */
  .filter-input >>> .v-input__control > .v-input__slot {
    border-radius: 0 !important;
    background-color: #1a1d26 !important;
    border-color: #3d5469 !important;
  }

  .filter-input >>> input {
    color: #d3d3d3 !important;
    font-size: 12px !important;
    font-weight: 400 !important;
  }

  .filter-input >>> .v-select__selection {
    color: #d3d3d3 !important;
    font-size: 12px !important;
  }

  .filter-input >>> .v-label {
    color: #999999 !important;
    font-size: 12px !important;
  }

  .filter-input >>> .v-icon {
    color: #999999 !important;
  }

  .filter-input >>> fieldset {
    border-color: #3d5469 !important;
  }

  .filter-input:hover >>> fieldset {
    border-color: #5a6b7f !important;
  }

  /* Filter Button Styling */
  .filter-btn {
    border-color: #5a6b7f !important;
    color: #d3d3d3 !important;
    font-size: 12px !important;
    text-transform: none !important;
  }

  .filter-btn:hover {
    background-color: rgba(255, 255, 255, 0.05) !important;
    border-color: #7a8b9f !important;
  }

  /* Remove old styles */
  .filters-card .v-text-field >>> .v-input__control > .v-input__slot {
    border-radius: 0 !important;
  }

  .filters-card .v-autocomplete >>> .v-input__control > .v-input__slot {
    border-radius: 0 !important;
  }

  .filters-card .v-select >>> .v-input__control > .v-input__slot {
    border-radius: 0 !important;
  }

  /* Data Table Card - Finviz Dark */
  .data-table-card {
    border-radius: 0 !important;
    background-color: #1a1d26 !important;
    border: 1px solid #3d5469 !important;
    overflow: hidden;
  }

  .modern-table {
    border-radius: 0;
    background-color: #1a1d26 !important;
  }

  /* Increase font size across data table */
  .modern-table >>> tbody tr td {
    font-size: 14px !important;
  }

  .modern-table >>> thead tr th {
    font-size: 14px !important;
  }

  .modern-table >>> .v-data-table-header {
    background-color: #2c3e50 !important;
  }

  .modern-table >>> .v-data-table-header th {
    background-color: #2c3e50 !important;
    color: #ffffff !important;
    font-weight: 500 !important;
    font-size: 12px !important;
    padding: 8px 12px !important;
    height: 36px !important;
    line-height: 1.3 !important;
    border-right: 1px solid #3d5469 !important;
    text-transform: none !important;
    letter-spacing: 0.3px !important;
  }

  .modern-table >>> .v-data-table-header th:last-child {
    border-right: none !important;
  }

  .modern-table >>> .v-data-table-header th .v-icon {
    color: white !important;
    font-size: 16px !important;
  }

  .modern-table >>> thead tr {
    background-color: #2c3e50 !important;
  }

  .modern-table >>> thead tr th {
    background-color: #2c3e50 !important;
    color: #ffffff !important;
  }

  .modern-table >>> tbody tr {
    transition: background-color 0.15s ease;
  }

  .modern-table >>> tbody tr:nth-child(odd) {
    background-color: #1a1d26 !important;
  }

  .modern-table >>> tbody tr:nth-child(even) {
    background-color: #21252e !important;
  }

  .modern-table >>> tbody tr:hover {
    background-color: #2a3040 !important;
  }

  .modern-table >>> tbody td {
    padding: 2px 6px !important;
    font-size: 12px !important;
    height: 24px !important;
    line-height: 1.3 !important;
    color: #d3d3d3 !important;
    border-bottom: 1px solid #2a2e39 !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-weight: 400 !important;
  }

  /* Email link styling - Finviz blue */
  .email-link {
    color: #3399ff !important;
    font-weight: 500 !important;
    cursor: pointer;
  }

  .email-link:hover {
    color: #66b3ff !important;
    text-decoration: underline;
  }

  /* Amount value styling - Finviz green */
  .amount-value {
    color: #00ff00 !important;
    font-weight: 500 !important;
  }

  .modern-table >>> .v-data-table__wrapper {
    font-size: 0.75rem !important;
  }

  .modern-table >>> .v-data-footer {
    padding: 4px 8px !important;
    font-size: 0.75rem !important;
  }

  .modern-table >>> .v-data-footer__select .v-select {
    margin: 0 4px !important;
  }

  .modern-table >>> .v-data-footer__select .v-select__selection {
    font-size: 0.75rem !important;
  }

  .modern-table >>> .v-data-footer__pagination {
    font-size: 0.75rem !important;
  }

  /* Make checkboxes smaller */
  .modern-table >>> .v-simple-checkbox {
    transform: scale(0.85);
  }

  /* Make avatar icons in table smaller */
  .modern-table >>> .v-avatar {
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
  }

  .modern-table >>> .v-avatar .v-icon {
    font-size: 14px !important;
  }

  /* Make chips smaller */
  .modern-table >>> .v-chip {
    height: 20px !important;
    font-size: 0.7rem !important;
    padding: 0 6px !important;
  }

  /* Compact expansion panels */
  .modern-table >>> .v-data-table__expand-icon {
    transform: scale(0.85);
  }

  .title {
    color: white;
    background-color: #617997;
    font-size: medium;
  }

  .rounded-pill {
    border-radius: 5px;
  }

  .test_cursor input {
    cursor: pointer;
  }

/* New Dashboard Stats Styles - Finviz Dark Theme */
.stats-dashboard {
  background-color: #0f1419 !important;
  margin: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Stats Header Card */
.stats-header-card {
  border-radius: 0 !important;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #2c3e50 !important;
  border: 1px solid #3d5469 !important;
}

.stats-header-card:hover {
  border-color: #5a6b7f !important;
  background-color: #34495e !important;
}

.stats-header-clickable {
  user-select: none;
}

.compact-chip {
  height: 22px !important;
  font-size: 0.75rem !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15) !important;
  letter-spacing: 0.3px !important;
}

/* Summary Cards */
.summary-card {
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
}

.gradient-blue {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.gradient-purple {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.gradient-green {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.summary-label {
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  opacity: 0.95;
  margin-bottom: 1px;
  line-height: 1.1;
}

.summary-value {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
}

/* Status Section Card */
.status-section-card {
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.section-title {
  background: linear-gradient(to right, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e9ecef;
}

/* Stat Boxes */
.stat-box {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 6px 6px;
  text-align: center;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  height: 100%;
}

.stat-box:hover {
  transform: translateY(-1px);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
}

.paid-box {
  background: linear-gradient(135deg, #e8f5e9 0%, #f1f8f4 100%);
  border-color: #c8e6c9;
}

.partial-paid-box {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border-color: #ffcc80;
}

.unpaid-box {
  background: linear-gradient(135deg, #ffebee 0%, #fce4ec 100%);
  border-color: #ffcdd2;
}

.category-box {
  background: white;
  border: 1px solid #e9ecef;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.adults-box:hover {
  border-color: #ff9800;
}

.kids-box:hover {
  border-color: #e91e63;
}

.parents-box:hover {
  border-color: #673ab7;
}

.stat-box-label {
  font-size: 0.6rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 1px;
  line-height: 1.1;
}

.stat-box-value {
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.1;
}

/* Breakdown Items */
.stat-breakdown {
  font-size: 0.7rem;
}

.breakdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px 0;
}

.breakdown-label {
  color: #666;
  font-weight: 500;
  font-size: 0.65rem;
}

.breakdown-value {
  font-weight: 700;
  font-size: 0.85rem;
}

/* Responsive Design for Stats */
@media (max-width: 960px) {
  .summary-value {
    font-size: 1.35rem;
  }

  .stat-box-value {
    font-size: 1.2rem;
  }

  .summary-label {
    font-size: 0.55rem;
  }

  .stat-box-label {
    font-size: 0.55rem;
  }
}

@media (max-width: 600px) {
  .summary-value {
    font-size: 1.15rem;
  }

  .summary-label {
    font-size: 0.5rem;
  }

  .stat-box {
    padding: 5px 4px;
  }

  .stat-box-value {
    font-size: 1rem;
  }

  .stat-box-label {
    font-size: 0.5rem;
  }

  .breakdown-label {
    font-size: 0.6rem;
  }

  .breakdown-value {
    font-size: 0.75rem;
  }
}

/* Checked In Summary Card - Finviz Dark */
.checked-in-summary-card {
  border-radius: 0 !important;
  border-left: 3px solid #00ff00 !important;
  background-color: #2c3e50 !important;
  border: 1px solid #3d5469 !important;
}

.checked-in-label {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.checked-in-value {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: #00ff00 !important;
}

/* Payment Stats Table Styling - Finviz Dark */
.stats-table-card {
  border-radius: 0 !important;
  overflow: hidden;
  background-color: #1a1d26 !important;
  border: 1px solid #3d5469 !important;
}

.payment-stats-table {
  border-radius: 0 !important;
  background-color: #1a1d26 !important;
}

.payment-stats-table table {
  border-collapse: collapse !important;
  background-color: #1a1d26 !important;
}

.compact-stats-table table {
  font-size: 12px !important;
}

.stats-header-row {
  background-color: #2c3e50 !important;
}

.stats-header-cell {
  color: #ffffff !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  padding: 6px 10px !important;
  border-right: 1px solid #3d5469 !important;
}

.stats-header-cell:last-child {
  border-right: none !important;
}

.not-paid-header {
  background-color: rgba(244, 67, 54, 0.2) !important;
}

.paid-header {
  background-color: rgba(76, 175, 80, 0.2) !important;
}

.partial-paid-header {
  background-color: rgba(255, 152, 0, 0.2) !important;
}

.total-header {
  background-color: rgba(158, 158, 158, 0.2) !important;
  font-weight: 800 !important;
}

.stats-row {
  transition: background-color 0.15s ease;
  background-color: #1a1d26 !important;
}

.stats-row:nth-child(even) {
  background-color: #21252e !important;
}

.stats-row:hover {
  background-color: #2a3040 !important;
}

.stats-label-cell {
  font-weight: 500 !important;
  font-size: 12px !important;
  padding: 4px 10px !important;
  color: #d3d3d3 !important;
  border-right: 1px solid #3d5469 !important;
}

.stats-value-cell {
  font-size: 12px !important;
  font-weight: 500 !important;
  padding: 4px 10px !important;
  border-right: 1px solid #3d5469 !important;
}

.stats-value-cell:last-child {
  border-right: none !important;
}

.not-paid-cell {
  color: #ff4444 !important;
  background-color: rgba(255, 68, 68, 0.1) !important;
}

.paid-cell {
  color: #00ff00 !important;
  background-color: rgba(0, 255, 0, 0.05) !important;
}

.partial-paid-cell {
  color: #ffa500 !important;
  background-color: rgba(255, 165, 0, 0.05) !important;
}

.total-cell {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.05) !important;
  font-weight: 600 !important;
}

.stats-total-row {
  background-color: #2a3040 !important;
  border-top: 1px solid #3d5469 !important;
}

.stats-total-label {
  font-weight: 600 !important;
  font-size: 12px !important;
  padding: 6px 10px !important;
  color: #ffffff !important;
  border-right: 1px solid #3d5469 !important;
}

.stats-total-value {
  font-size: 13px !important;
  font-weight: 600 !important;
  padding: 6px 10px !important;
  border-right: 1px solid #3d5469 !important;
}

.stats-total-value:last-child {
  border-right: none !important;
}

.not-paid-total {
  color: #ff4444 !important;
}

.paid-total {
  color: #00ff00 !important;
}

.partial-paid-total {
  color: #ffa500 !important;
}

.grand-total {
  color: #3399ff !important;
  font-weight: 700 !important;
  background-color: rgba(51, 153, 255, 0.1) !important;
}

/* Total HC Row Styling */
.stats-total-hc-row {
  background-color: #34495e !important;
  border-top: 1px solid #3d5469 !important;
}

.stats-total-hc-label {
  font-weight: 700 !important;
  font-size: 12px !important;
  padding: 6px 10px !important;
  color: #ffffff !important;
  border-right: 1px solid #3d5469 !important;
}

.stats-total-hc-value {
  font-size: 13px !important;
  font-weight: 700 !important;
  padding: 6px 10px !important;
  color: #ffffff !important;
  border-right: 1px solid #3d5469 !important;
}

.stats-total-hc-value:last-child {
  border-right: none !important;
}

.paid-hc-total {
  background-color: rgba(76, 175, 80, 0.15) !important;
}

/* Checked In Row Styling */
.stats-checkedin-row {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
  border-top: 2px solid #42a5f5 !important;
}

.stats-checkedin-label {
  font-weight: 800 !important;
  font-size: 14px !important;
  padding: 8px 12px !important;
  color: #0d47a1 !important;
  border-right: 1px solid #42a5f5 !important;
}

.stats-checkedin-value {
  font-size: 16px !important;
  font-weight: 800 !important;
  padding: 8px 12px !important;
  color: #0d47a1 !important;
  background-color: rgba(33, 150, 243, 0.15) !important;
}

/* Check-In Toggle Switch Styling */
.check-in-toggle {
  margin: 0 !important;
  padding: 0 !important;
}

.check-in-toggle >>> .v-input__slot {
  margin: 0 !important;
  padding: 0 !important;
}

.check-in-toggle >>> .v-input--selection-controls__input {
  margin-right: 6px !important;
}

.check-in-toggle >>> .v-label {
  font-size: 12px !important;
  margin: 0 !important;
}

/* Modern toggle appearance */
.check-in-toggle >>> .v-input--switch__track {
  width: 36px !important;
  height: 20px !important;
  opacity: 1 !important;
}

.check-in-toggle >>> .v-input--switch__thumb {
  width: 16px !important;
  height: 16px !important;
  top: 2px !important;
}

/* Default/Unchecked state - red */
.check-in-toggle >>> .v-input--switch__track {
  background-color: #f44336 !important;
}

.check-in-toggle >>> .v-input--switch__thumb {
  background-color: white !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2) !important;
}

/* Checked/Active state - green */
.check-in-toggle.v-input--is-dirty >>> .v-input--switch__track,
.check-in-toggle >>> .v-input--is-dirty .v-input--switch__track {
  background-color: #4caf50 !important;
}

.check-in-toggle.v-input--is-dirty >>> .v-input--switch__thumb,
.check-in-toggle >>> .v-input--is-dirty .v-input--switch__thumb {
  background-color: white !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2) !important;
}

/* Hover effect */
.check-in-toggle:hover >>> .v-input--switch__track {
  opacity: 0.9;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Loading state */
.check-in-toggle >>> .v-input--is-loading .v-input--switch__track {
  opacity: 0.6;
}

/* Payment Comment Tooltip Styling */
.payment-comment-tooltip {
  background-color: #FF9800 !important;
  color: #000000 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding: 20px 24px !important;
  border-radius: 6px !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3) !important;
  line-height: 1.6 !important;
  letter-spacing: 0.3px !important;
}

.payment-comment-tooltip .v-tooltip__content {
  background-color: #FF9800 !important;
  color: #000000 !important;
}
</style>